const SESSION_TOKEN = 'session_token'

function bearer(axios, token = null) {
  if (token) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`
  } else {
    delete axios.defaults.headers.common.Authorization
  }
}

class Auth {
  constructor(axios) {
    this._axios = axios
    const token = Auth.getToken()
    bearer(axios, token)
  }

  static getToken() {
    return localStorage.getItem(SESSION_TOKEN)
  }

  static setToken(token) {
    localStorage.setItem(SESSION_TOKEN, token)
  }

  static clearToken() {
    localStorage.removeItem(SESSION_TOKEN)
  }

  async login(credentials) {
    const { data } = await this._axios.post('/login', credentials)
    const { token } = data.data
    Auth.setToken(token)
    bearer(this._axios, token)
  }

  async logout() {
    try {
      await this._axios.get('/logout')
    } catch (error) { /* do nothing */ }
    Auth.clearToken()
    bearer(this._axios, null)
  }
}

export default Auth
